var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolluxInvertedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rollux_B1_black_yellow",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 288 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #dbef88;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 144,
    r: 127.49
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "87.69 78.17 92.96 78.17 219.35 194.03 219.35 209.83 87.69 209.83 87.69 78.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m187.36,154.61c3.62-7.14,5.66-15.22,5.66-23.78,0-29.09-23.58-52.66-52.66-52.66-10.19,0-19.7,2.9-27.76,7.91l74.76,68.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolluxInvertedLogo);
export default __webpack_public_path__ + "static/media/rollux_inverted_logo.76304f4e627bd6250099ce7db9fcefbb.svg";
export { ForwardRef as ReactComponent };